/**
 * Guard to make sure we are talking about a KeyboardEvent
 */
export function isKeyboardEvent(event: KeyboardEvent | InputEvent): event is KeyboardEvent {
  return 'key' in (event as KeyboardEvent)
}
